import * as nodePath from 'node:path';
import { toast } from 'react-toastify';
import { ToastMessage } from '~/components/ui/ToastMessage';

interface IsValidAttachmentOptions {
  isDirectory?: boolean;
  allowedExtensions?: Set<string>;
}

export function isValidAttachment(
  file: File | null,
  { isDirectory, allowedExtensions }: IsValidAttachmentOptions = {},
) {
  if (!file) {
    return false;
  }

  if (isDirectory) {
    toast.error(<ToastMessage title="Failed to upload folder" message="Adding folders is not supported" />);
    return false;
  }

  if (!file?.name) {
    toast.error(<ToastMessage title="Failed to upload file" message="File name missing" />);
    return false;
  }

  const extension = nodePath.extname(file.name).toLowerCase();

  if (allowedExtensions && (!extension || !allowedExtensions.has(extension))) {
    toast.error(<ToastMessage title="Failed to upload file" message="Unsupported file type" />);
    return false;
  }

  return true;
}
